import React from 'react'
import { Link } from "react-router-dom";


const OurFaculty = () => {
    return (
        <>

            <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
                <div className="container">
                    <div className="row">
                        <div className="page-heading">
                            <h2 className="wow fadeInUp" data-wow-delay=".3s">Our Faculty</h2>
                            <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li><i className="fa-solid fa-chevron-right" /></li>
                                <li>Our Faculty</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="team-section section-padding fix">
                <div className="container">
                    <div className="row g-4">

                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Santosh Mani Sharma.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Santosh Mani Sharma</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Principal )</b></p>
                                    {/* <div className="social-profile">
                                        <ul>
                                            <li><a to="#"><i className="fa-brands fa-facebook" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-twitter" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                                        </ul>
                                        <span className="plus-btn"><i className="fa-solid fa-plus" /></span>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Virendra Singh.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Virendra Singh</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Lecturer Biology )</b></p>
                                    {/* <div className="social-profile">
                                        <ul>
                                            <li><a to="#"><i className="fa-brands fa-facebook" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-twitter" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                                        </ul>
                                        <span className="plus-btn"><i className="fa-solid fa-plus" /></span>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Lavakush Ram. Pandey.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Lavakush Ram. Pandey</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Commerce lecturer )</b></p>
                                    {/* <div className="social-profile">
                                        <ul>
                                            <li><a to="#"><i className="fa-brands fa-facebook" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-twitter" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                                        </ul>
                                        <span className="plus-btn"><i className="fa-solid fa-plus" /></span>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Santosh Kumar Mishra.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Santosh Kumar Mishra</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Lecturer Hindi )</b></p>
                                    {/* <div className="social-profile">
                                        <ul>
                                            <li><a to="#"><i className="fa-brands fa-facebook" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-twitter" /></a></li>
                                            <li><a to="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                                        </ul>
                                        <span className="plus-btn"><i className="fa-solid fa-plus" /></span>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Jyoti Kundwani.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Ms. Jyoti Kundwani</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Academic Director )</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Sangeeta Tripathi.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Ms. Sangeeta Tripathi</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( UDT Maths )</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Shilpi Tiwari.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Ms. Shilpi Tiwari</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( 
                                        Computer Science )</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Anamika Dubey.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Ms. Anamika Dubey</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Lecturer (PGT English) )</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Poonam Shrivastava.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Ms. Poonam Shrivastava</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Music faculty )</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/xxxxxxx.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Teacher</a>
                                    </h4>
                                    {/* <p style={{ textAlign: "center" }}><b>( Teacher )</b></p> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Ranjit Prasad Pandey.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Ranjit Prasad Pandey</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Assistant Professor )</b></p>

                                </div>
                            </div>
                        </div>

                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Abhishek Sharma.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Abhishek Sharma</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( English lecture )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Alok Pandey.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Alok Pandey</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Librarian )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Ghanshyam tiwari.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Ghanshyam tiwari</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( UDT(Maths) )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Lovkush Prasad Mishra.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Lovkush Prasad Mishra</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Mathematics Lecturer  )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Onkar Yadav.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Onkar Yadav</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Teacher )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Rajiv Lochan Tiwari.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Rajiv Lochan Tiwari</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Chemistry Lecturer )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Ramanand mishra.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Ramanand mishra</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Sanskrit Teacher )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Umakant Pandey.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Umakant Pandey</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Teacher )</b></p>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="team-card-item mt-0">
                                <div className="team-image">
                                    <img src="assets/img/svp/Vishnu Prasad Dwivedi.png" alt="img" />
                                </div>
                                <div className="team-content">
                                    <h4 style={{ textAlign: "center" }}>
                                        <a to="team-details.html" style={{ textAlign: "center" }}>Mr. Vishnu Prasad Dwivedi</a>
                                    </h4>
                                    <p style={{ textAlign: "center" }}><b>( Teacher )</b></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </>
    )
}

export default OurFaculty